import {ChangeDetectionStrategy, Component, Signal} from "@angular/core";
import {navParam} from "../../navigation/navigation-params";
import {Page} from "../../navigation/page";
import {RecentOrderData} from "../recent-order.service";
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {OrderDetailsPanelComponent} from "../order-details-panel/order-details-panel.component";

@Component({
    selector: "woa-order-details-page",
    templateUrl: "./order-details-page.component.html",
    providers: [{provide: Page, useExisting: OrderDetailsPageComponent}],
    imports: [
        ModalPageLayoutComponent,
        OrderDetailsPanelComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class OrderDetailsPageComponent extends Page {
    public readonly recentOrder: Signal<RecentOrderData> = navParam.required<RecentOrderData>("recentOrder");
}
